import { VARIABLE_TYPE_ENUM } from "@/hooks/useGetTypes/enums";

export const getValue = (
  allParams: any,
  parameterType: VARIABLE_TYPE_ENUM | string
) => {
  if (
    parameterType === VARIABLE_TYPE_ENUM.ARRAY_ITEM_ID ||
    parameterType === VARIABLE_TYPE_ENUM.ITEM_ID
  ) {
    if (allParams[parameterType]?.length > 1) {
      return `${
        allParams[parameterType][0]?.title ?? allParams[parameterType][0]?.name
      } ...`;
    }
    if (allParams[parameterType]?.length === 1) {
      return (
        allParams[parameterType][0]?.title ?? allParams[parameterType][0]?.name
      );
    }
  }
  if (parameterType === VARIABLE_TYPE_ENUM.ARRAY_STRING) {
    return `[${allParams[parameterType]
      ?.map((param: string) => `"${param}"`)
      ?.join(";")}]`;
  }
  return (
    allParams[parameterType]?.title ??
    allParams[parameterType]?.name ??
    allParams[parameterType]
  );
};
